export default {
    type: 'location-modules',
    aliases: {
        camel: 'locationModules',
        singular: 'Location module',
        plural: 'Location modules',
        lowerSingular: 'location module',
        lowerPlural: 'location modules',
    },
    publishable: false,
    adminSection: null,
    componentType: 'pivot',
    components: {}
};
